import _prettyBytes from "pretty-bytes";

export const prettyBytes = (bytes: number) => {
  return _prettyBytes(bytes, { binary: true }).replace("iB", "B");
};
